import styled from 'styled-components';
import FlightSvg from '../../assets/verticals/flight.svg';

const FlightIcon = styled(FlightSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4rem'};
height: ${props => props.height || '3rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default FlightIcon;
